import { Controller } from "stimulus"

export default class extends Controller {

  static values = {
    url: String
  }

  filter (event) {
    document.getElementById('futures_position').src = this.urlValue;
  }
}